module.exports = __webpack_public_path__ + "static/img/75.3a875d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/23/75.jpg
// module id = 739
// module chunks = 0